import { useAuth } from "@workos-inc/authkit-react";

/**
 * Single reader of WorkOS feature flags. Flags arrive with the auth context
 * at login (no API call). Named convenience wrappers exist for the two
 * widely-used flags (useCoApprovalEnabled, useHitlEnabled); single-site
 * flags call this directly with their feature's exported constant.
 */
export function useFeatureFlag(flag: string): boolean {
  const { featureFlags } = useAuth();
  return (featureFlags ?? []).includes(flag);
}
